export default "__VITE_ASSET__5466e7e2__"